import Header, { HeaderLeft } from "../../../layout/Header/Header";
import CommonHeaderRight from "./CommonHeaderRight";

const AccountExpensesHeader = () => {
  return (
    <Header>
      <HeaderLeft>
        <div>
          <div className="fw-bold fs-6 mb-0">Account Expenses</div>
          <div className="text-muted">
            <small>
              All outgoing payments by the flat.
            </small>
          </div>
        </div>
      </HeaderLeft>
      <CommonHeaderRight />
    </Header>
  );
};

export default AccountExpensesHeader;
